// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Clients = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Clients = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Clients = _exports.Clients = function Clients(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M14.0841 17.22V15.5845C14.0841 14.717 13.7395 13.885 13.1261 13.2715C12.5126 12.6581 11.6806 12.3135 10.8131 12.3135H4.27103C3.4035 12.3135 2.5715 12.6581 1.95806 13.2715C1.34463 13.885 1 14.717 1 15.5845V17.22",
      stroke: "#212B36",
      "stroke-width": "1.25",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M7.54252 9.04207C9.34906 9.04207 10.8136 7.57758 10.8136 5.77103C10.8136 3.96449 9.34906 2.5 7.54252 2.5C5.73598 2.5 4.27148 3.96449 4.27148 5.77103C4.27148 7.57758 5.73598 9.04207 7.54252 9.04207Z",
      stroke: "#212B36",
      "stroke-width": "1.25",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M18.9904 17.2192V15.5837C18.9898 14.8589 18.7486 14.1549 18.3046 13.5821C17.8605 13.0093 17.2389 12.6001 16.5371 12.4189",
      stroke: "#212B36",
      "stroke-width": "1.25",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M13.2676 2.60547C13.9712 2.78562 14.5948 3.19483 15.0402 3.76857C15.4855 4.34232 15.7273 5.04797 15.7273 5.77428C15.7273 6.50059 15.4855 7.20624 15.0402 7.77999C14.5948 8.35374 13.9712 8.76294 13.2676 8.9431",
      stroke: "#212B36",
      "stroke-width": "1.25",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }));
  };
});
